const WHOLE_NUMBER_PATTERN = /^\d*$/;
const DECIMAL_NUMBER_PATTERN = /^\d*[.,]?\d*$/;
const SIGNED_WHOLE_NUMBER_PATTERN = /^-?\d*$/;
const SIGNED_DECIMAL_NUMBER_PATTERN = /^-?\d*[.,]?\d*$/;
const LEADING_ZERO_PATTERN = /^(-?)0+(?=\d)/;
const DECIMAL_COMMA = ",";
const DECIMAL_POINT = ".";

interface ParseNumberInputOptions {
  rawValue: string;
  allowDecimals?: boolean;
  allowNegative?: boolean;
}

interface ParsedNumberInput {
  draft: string;
  value: number | null;
}

const resolveAcceptedPattern = ({
  allowDecimals,
  allowNegative,
}: Required<Omit<ParseNumberInputOptions, "rawValue">>): RegExp => {
  if (allowNegative) {
    return allowDecimals ? SIGNED_DECIMAL_NUMBER_PATTERN : SIGNED_WHOLE_NUMBER_PATTERN;
  }
  return allowDecimals ? DECIMAL_NUMBER_PATTERN : WHOLE_NUMBER_PATTERN;
};

const toNumber = (draft: string): number | null => {
  const parsed = Number(draft.replace(DECIMAL_COMMA, DECIMAL_POINT));
  return Number.isFinite(parsed) ? parsed : null;
};

export const parseNumberInput = ({
  rawValue,
  allowDecimals = false,
  allowNegative = false,
}: ParseNumberInputOptions): ParsedNumberInput | null => {
  if (!resolveAcceptedPattern({ allowDecimals, allowNegative }).test(rawValue)) {
    return null;
  }

  const draft = rawValue.replace(LEADING_ZERO_PATTERN, "$1");
  return { draft, value: draft === "" ? null : toNumber(draft) };
};
